import React from 'react';
import { IConcreteJobConfirmationPopupProperties, IJobResultComponentProps } from '../jobs-monitor-host.viewmodel';
import { IGenerateAccessCodesJobDetails, IGenerateAccessCodesJobResult } from '../../../api/jobs.dao';

const generateConnectionsTriggerJobProperties:
    IConcreteJobConfirmationPopupProperties<IJobResultComponentProps<IGenerateAccessCodesJobDetails, IGenerateAccessCodesJobResult>> = {
    reviewCompletedJobButtonText: 'Ok',
    reviewFailedJobButtonText: 'Ok',
    completeComponent: () => {
        return <span className='alert-message'>Generate Connections was successful</span>;
    },
    failedComponent: () => {
        return <span className='alert-message'>Generate Connections was failed</span>;
    }
};

export { generateConnectionsTriggerJobProperties };